(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pg-long-description"] && !Shopify.designMode) return;
  try {
    /* Makes the reading area reachable by keyboard and announced by screen readers, only while it really scrolls */
  (() => {
    const watched = new WeakSet();
    const sync = (el) => {
      const details = el.closest('details');
      const scrolls = !!details && details.open && el.clientHeight > 0 && el.scrollHeight > el.clientHeight + 1;
      if (scrolls) {
        el.setAttribute('tabindex', '0');
        el.setAttribute('role', 'region');
        el.setAttribute('aria-label', el.dataset.longLabel || '');
      } else {
        el.removeAttribute('tabindex');
        el.removeAttribute('role');
        el.removeAttribute('aria-label');
      }
    };
    const watch = () => {
      document.querySelectorAll('.pg__long--scroll').forEach((el) => {
        if (!watched.has(el)) {
          watched.add(el);
          if ('ResizeObserver' in window) new ResizeObserver(() => sync(el)).observe(el);
        }
        sync(el);
      });
    };
    // the toggle event of <details> does not bubble: listen in the capture phase
    document.addEventListener('toggle', watch, true);
    document.addEventListener('shopify:section:load', watch);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
  })();
  } catch(e) { console.error(e); }
})();

})();
